import isFunction from 'lodash/isFunction'
import isString from 'lodash/isString'
import { DateTime } from 'luxon'
import { isLoyalCriteria, isInSegmentCriteria } from '@/components/quick-actions/segmentationGroups.js'

export function applyQuickActionsFormatters(description, stateFilters) {
  if (isFunction(description)) {
    return description(stateFilters)
  } else if (isString(description)) {
    return description
  } else {
    return ''
  }
}

export function getNumberOfAppliedFilters({ fidelidade, pessoa, segments, units }) {
  let numberOfAppliedFilters = 0
  if (fidelidade !== '') {
    numberOfAppliedFilters += 1
  }
  if (pessoa !== '') {
    numberOfAppliedFilters += 1
  }
  if (segments?.length) {
    numberOfAppliedFilters += 1
  }
  if (units?.length) {
    numberOfAppliedFilters += 1
  }
  return numberOfAppliedFilters
}

export function quickActionDescriptionFormatters(stateFilters) {
  const numberOfAppliedFilters = getNumberOfAppliedFilters(stateFilters)
  const formatters = {
    startDate: '',
    endDate: '',
    filtered: '',
  }
  if (stateFilters?.data?.length) {
    const dates = stateFilters.data.map((date) => DateTime.fromFormat(date, 'yyyy-MM-dd').toLocaleString())
    if (dates.length === 1) {
      formatters.startDate = dates[0]
      formatters.endDate = dates[0]
    } else {
      formatters.startDate = dates[0]
      formatters.endDate = dates[1]
    }
  }
  if (numberOfAppliedFilters) {
    formatters.filtered = ' - Filtrado'
  }
  return formatters
}

export function quickActionFiltersCriteria(stateFilters) {
  const criteria = {
    segments: [],
    units: [],
    loyalty: [],
    clientGroups: [],
  }
  let dateCriteriaFilter = []
  if ([0, 1].includes(stateFilters?.fidelidade)) {
    criteria.loyalty.push(isLoyalCriteria(stateFilters.fidelidade === 1))
  }
  if (stateFilters?.data?.length) {
    dateCriteriaFilter = stateFilters.data.map((date) => date.replace(/[^0-9]/g, ''))
    if (dateCriteriaFilter.length === 1) {
      // Repeat the same date in the filter
      dateCriteriaFilter.push(dateCriteriaFilter[0])
    }
  }
  if (stateFilters?.segmentsObjects?.length) {
    stateFilters.segmentsObjects.forEach((segment) => {
      criteria.segments.push(isInSegmentCriteria(segment))
    })
  }
  if (stateFilters?.unitsConfiguration?.length) {
    if (dateCriteriaFilter.length) {
      criteria.units.push([
        { id: 0, value: 0 },
        { id: 0, value: 0 },
        { id: 2, value: 0 },
        { id: 0, value: stateFilters.unitsConfiguration },
        { id: 0, value: 1 },
        { id: 1, value: dateCriteriaFilter },
        { id: 0, value: 0 },
        { id: 0, value: 0 },
      ])
    } else {
      criteria.units.push([
        { id: 0, value: 0 },
        { id: 0, value: 0 },
        { id: 2, value: 0 },
        { id: 0, value: stateFilters.unitsConfiguration },
        { id: 0, value: 2 },
        { id: 2, value: 0 },
        { id: 0, value: 0 },
        { id: 0, value: 0 },
      ])
    }
  }
  return { criteria, dateCriteriaFilter, stateFilters }
}
